import React, { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import DataGrid from 'react-data-grid'
import './index.css'
import { Icon } from '@iconify/react'
import RevisedPolicy from '../components/RevisedLeavePolicy'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../../redux/hook'
import { getUserStats, timeOffSearch } from '../api'
import { useAppDispatch } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { Carousel } from 'react-bootstrap'
import { formatDate } from '../../../resources/empresources/utils/index'
import {
    TimeOffDataType,
    UserStatsType,
    RevisedLeavePolicyType,
} from '../../type'
import ViewTimeOffDetail from '../components/ViewTimeOffDetailModal'
import { getLeavePolicyDetails } from '../../../leavepolicy/editpolicy/api'
import { leaveTypedDetaiI } from '../../../holidays/components/types'

const Timeoffinfo: React.FC<{
    userId: string
    otherUserId: string | null
    isActive: boolean
    userLeavePolicyId: string
}> = ({ userId, otherUserId, isActive, userLeavePolicyId }) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const [showpolicyModal, setShowPolicyModal] = useState<boolean>(false)
    const [showTimeoffDetailModal, setShowTimeoffDetailModal] =
        useState<boolean>(false)
    const [userStats, setUserStats] = useState<UserStatsType[]>([])
    const [timeOffData, setTimeOffData] = useState<TimeOffDataType[]>([])
    const [selectedFilter, setSelectedFilter] = useState<string>('Upcoming')
    const [currentLeavePolicy, setCurrentLeavePolicy] =
        useState<RevisedLeavePolicyType>({
            label: '',
            value: '',
        })

    const [leaveTypeDetails, setLeaveTypeDetails] = useState<
        UserStatsType | any
    >(null)
    const [leaveTypeDetailsAdd, setLeaveTypeDetailsAdd] = useState<
        leaveTypedDetaiI[]
    >([])

    const { role } = useAppSelector((state) => state.persistedReducers.user)
    const currentDate = new Date().toISOString()

    useEffect(() => {
        const fetchData = async () => {
            const param = {
                userId: otherUserId,
            }
            dispatch(SHOW_LOADER())
            try {
                const response = await getUserStats(param)
                setUserStats(response.data.data)
            } catch (error) {
                console.error(error)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }
        if (isActive) {
            fetchData()
        }
    }, [dispatch, otherUserId, isActive, currentLeavePolicy])

    useEffect(() => {
        const fetchData = async () => {
            if (userLeavePolicyId) {
                try {
                    dispatch(SHOW_LOADER())
                    const response =
                        await getLeavePolicyDetails(userLeavePolicyId)
                    setLeaveTypeDetailsAdd(response.data.leavePolicyDetails)
                } catch (error) {
                    console.error(error)
                } finally {
                    dispatch(HIDE_LOADER())
                }
            }
        }
        if (isActive) {
            fetchData()
        }
    }, [userLeavePolicyId, isActive, otherUserId])

    useEffect(() => {
        const fetchData = async () => {
            dispatch(SHOW_LOADER())
            try {
                let requestBody = {}

                if (selectedFilter === 'Upcoming') {
                    requestBody = {
                        advancedSearch: {
                            fields: [],
                            keyword: '',
                        },
                        keyword: '',
                        advancedFilter: {
                            logic: 'and',
                            filters: [
                                {
                                    field: 'UserID',
                                    operator: 'eq',
                                    value: userId,
                                },
                                {
                                    field: 'CreatedBy',
                                    operator: 'eq',
                                    value: userId,
                                },
                                {
                                    field: 'StartDate',
                                    operator: 'gte',
                                    value: currentDate,
                                },
                            ],
                            field: '',
                            operator: '',
                            value: '',
                        },
                        pageNumber: 0,
                        pageSize: 0,
                        orderBy: ['StartDate asc'],
                        personalAppliedLeaves: false,
                        assignedLeavesToMe: false,
                        upcmoingLeaveOfUser: true,
                        pastLeaveOfUser: false,
                        userId: null,
                    }
                } else if (selectedFilter === 'Past') {
                    requestBody = {
                        advancedSearch: {
                            fields: [],
                            keyword: '',
                        },
                        keyword: '',
                        advancedFilter: {
                            logic: 'and',
                            filters: [
                                {
                                    field: 'UserID',
                                    operator: 'eq',
                                    value: userId,
                                },
                                {
                                    field: 'CreatedBy',
                                    operator: 'eq',
                                    value: userId,
                                },
                                {
                                    field: 'StartDate',
                                    operator: 'lte',
                                    value: currentDate,
                                },
                            ],
                            field: '',
                            operator: '',
                            value: '',
                        },
                        pageNumber: 0,
                        pageSize: 0,
                        orderBy: ['StartDate asc'],
                        personalAppliedLeaves: false,
                        assignedLeavesToMe: false,
                        upcmoingLeaveOfUser: false,
                        pastLeaveOfUser: true,
                        userId: null,
                    }
                }

                const response = await timeOffSearch(requestBody)
                setTimeOffData(response?.data?.data || [])
            } catch (error) {
                console.error(error)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }
        if (isActive) {
            fetchData()
        }
    }, [selectedFilter, userId, isActive])

    const transformedRows =
        timeOffData?.map((item: any) => ({
            request: formatDate(item.requestedOn),
            start: formatDate(item.startDate),
            end: formatDate(item.endDate),
            policy: item.leaveType,
            status: item.status,
        })) || []

    const column = [
        {
            key: 'request',
            name: 'Request Date',
            resizable: true,
            sortable: true,
        },
        {
            key: 'start',
            name: 'Start Date',
            resizable: true,
            sortable: true,
        },
        {
            key: 'end',
            name: 'End Date',
            resizable: true,
            sortable: true,
        },
        {
            key: 'policy',
            name: 'Time Off Type',
            resizable: true,
            sortable: true,
        },
        {
            key: 'status',
            name: 'Status',
            resizable: true,
            sortable: true,
            renderCell: (props: any) => {
                return (
                    <div
                        className={
                            props.row.status === 'Pending' ? 'status' : 'comp'
                        }
                    >
                        {props.row.status}
                    </div>
                )
            },
        },
    ]

    const filteredStats = userStats.filter((stat: any) => stat.totalCount > 0)

    // Chunk the filtered stats array into subarrays of 5 items each
    const chunkedStats: any = []
    for (let i = 0; i < filteredStats.length; i += 5) {
        chunkedStats.push(filteredStats.slice(i, i + 5))
    }

    const handleStatClick = async (id: string) => {
        const leaveTypeDetail = leaveTypeDetailsAdd?.find(
            (detail: any) => detail?.leaveTypeId === id
        )
        if (leaveTypeDetail) {
            setLeaveTypeDetails(leaveTypeDetail)
        }
        setShowTimeoffDetailModal(true)
    }

    return (
        <div>
            <RevisedPolicy
                show={showpolicyModal}
                onClose={setShowPolicyModal}
                setCurrentLeavePolicy={setCurrentLeavePolicy}
                currentLeavePolicy={currentLeavePolicy}
                userLeavePolicyId={userLeavePolicyId}
                otherUserId={otherUserId}
            />
            <ViewTimeOffDetail
                show={showTimeoffDetailModal}
                onClose={setShowTimeoffDetailModal}
                leaveTypeDetails={leaveTypeDetails}
            />
            {role !== 'Employee' && (
                <div className="policy-section">
                    <div>
                        <h6>
                            Current Leave Policy :{' '}
                            {currentLeavePolicy?.label
                                ? currentLeavePolicy?.label
                                : '--'}
                            {role !== 'Teacher' &&
                                (role !== 'Manager' ||
                                    (role === 'Manager' && otherUserId)) && (
                                    <span className="ms-3">
                                        <Icon
                                            onClick={() => {
                                                setShowPolicyModal(true)
                                            }}
                                            icon="bx:edit"
                                            className="icon-primary"
                                            color="#3d87de"
                                            fontSize={'24px'}
                                            cursor={'pointer'}
                                        />
                                    </span>
                                )}
                        </h6>
                    </div>
                    {role !== 'Teacher' &&
                        (role !== 'Manager' ||
                            (role === 'Manager' && otherUserId)) && (
                            <div>
                                <div className="button-block">
                                    <a
                                        className="button button-primary"
                                        onClick={() =>
                                            navigate(
                                                otherUserId
                                                    ? `/users/apply-timeoff?userId=${otherUserId}`
                                                    : `/users/apply-timeoff?isGlobal=true`
                                            )
                                        }
                                    >
                                        {`TIME OFF (ON BEHALF OF)`}
                                    </a>
                                </div>
                            </div>
                        )}
                </div>
            )}

            <div className="time-off-info">
                <Carousel data-bs-theme="dark" slide={false}>
                    {chunkedStats.map((chunk: any, index: any) => (
                        <Carousel.Item key={index}>
                            <div className="carousel-inner">
                                {chunk.map((stat: any, subIndex: any) => (
                                    <div
                                        key={subIndex}
                                        className="carousel-item-custom"
                                        onClick={() =>
                                            handleStatClick(stat?.leaveTypeId)
                                        }
                                    >
                                        <div className="white-board">
                                            <label>{stat.leaveType}</label>
                                            <h3>{stat.remainingCount}</h3>
                                            <span>Days Available</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Carousel.Item>
                    ))}
                </Carousel>
            </div>
            <div className="time-off-info-input mt-4">
                <div className="col-sm-12">
                    <Form.Label>Time Off Type</Form.Label>
                    <Form.Select
                        size="lg"
                        className="bg-green-color"
                        value={selectedFilter}
                        onChange={(e) => setSelectedFilter(e.target.value)}
                    >
                        <option value="Upcoming">Upcoming</option>
                        <option value="Past">Past</option>
                    </Form.Select>
                </div>
            </div>
            <div className="table-wrapper grid-table-timeoff mt-4">
                {transformedRows?.length === 0 ? (
                    <div className="no-records-found">No records found</div>
                ) : (
                    <DataGrid
                        className="data-grid-table"
                        columns={column}
                        rows={transformedRows}
                        rowHeight={60}
                        headerRowHeight={40}
                    />
                )}
            </div>
        </div>
    )
}

export default Timeoffinfo
